import { useEffect } from "react";

import { Button, Popover, PopoverSurface, PopoverTrigger, Text } from "@fluentui/react-components";
import { FilterFilled } from "@fluentui/react-icons";
import { useAtom, useAtomValue } from "jotai";
import { devices } from "library/constants";
import { useTranslation } from "react-i18next";
import { selectedCategoryFilterAtom, selectedClientAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import styled from "styled-components";

import { Flex } from "components/styled";
import { useSetDefaultBenefitCurrency } from "hooks/useSetDefaultBenefitCurrency";

import { CategoryFilter } from "./CategoryFilter/CategoryFilter";
import { useFilterCategoryOptions } from "./CategoryFilter/useFilterCategoryOptions";
import { StatusFilter } from "./StatusFilter/StatusFilter";

export function FilterContent() {
  useSetDefaultBenefitCurrency();

  const { t } = useTranslation();

  const categoryOptions = useFilterCategoryOptions();
  const [categoryFilters, setSelectedCategoryFilters] = useAtom(selectedCategoryFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  const selectedClient = useAtomValue(selectedClientAtom);

  useEffect(() => {
    if (!categoryFilters[selectedContentTab] && !!categoryOptions.length) {
      setSelectedCategoryFilters((prev) => {
        return {
          ...prev,
          [selectedContentTab]: categoryOptions.map((item) => {
            return { id: item.id, name: item.name };
          }),
        };
      });
    }
  }, [categoryOptions, selectedClient]);

  useEffect(() => {
    setSelectedCategoryFilters({});
  }, [selectedClient]);

  return (
    <Flex wrap="nowrap">
      <Popover positioning={"below-end"}>
        <PopoverTrigger disableButtonEnhancement>
          <Button
            data-help="benefits-filter-button"
            appearance="transparent"
            style={{
              justifyContent: "flex-end",
              minWidth: "fit-content",
              maxWidth: "fit-content",
            }}
            icon={<FilterFilled fontSize={25} />}
          >
            <StyledText weight="semibold"> {t("greco.filter")}</StyledText>
          </Button>
        </PopoverTrigger>

        <PopoverSurface tabIndex={-1}>
          <Container>
            <CategoryFilter />
            <StatusFilter />
          </Container>
        </PopoverSurface>
      </Popover>
    </Flex>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  max-width: fit-content;
  gap: 40px;
`;
const StyledText = styled(Text)`
  display: none;

  @media only screen and ${devices.md} {
    display: block;
  }
`;
